import * as Common from "../Common/modules";
import { ContractAmendmentCustomerDetails, AmendNameAddressRequest } from "../Models/ContractAmendment";

export interface IContractAmendmentApiClient {
  
  getCurrentDetails: (igsCustomerNumber: string) => angular.IPromise<ContractAmendmentCustomerDetails>;

  submitContractAmendment: (request: AmendNameAddressRequest) => angular.IPromise<void>;

  cancelContractAmendment: (igsCustomerNumber: string) => angular.IPromise<void>;

  hasUploadedContractAmendmentRateDocumentType: (igsCustomerNumber: string) => angular.IPromise<boolean>;
}

export class ContractAmendmentApiClient implements IContractAmendmentApiClient {
  public prefix: string;

  public static $inject = [
    "igs.apiClientService"
  ];

  constructor(
    private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
    this.prefix = "ContractAmendment";
  }

  public getCurrentDetails(igsCustomerNumber: string): angular.IPromise<ContractAmendmentCustomerDetails> {
    var url = `${this.prefix}/CurrentDetails/${igsCustomerNumber}`;
    return this.igsApiClientService.get(url);
  }

  public submitContractAmendment(request: AmendNameAddressRequest): angular.IPromise<void> {
    var url = `${this.prefix}/Submit`;
    return this.igsApiClientService.post(url, request);
  }

  public cancelContractAmendment(igsCustomerNumber: string): angular.IPromise<void> {
    var url = `${this.prefix}/Cancel/${igsCustomerNumber}`;
    return this.igsApiClientService.post(url, null);
  }

  public hasUploadedContractAmendmentRateDocumentType(igsCustomerNumber: string): angular.IPromise<boolean> {
    var url = `${this.prefix}/HasUploadedContractAmendmentRateDocumentType/${igsCustomerNumber}`;
    return this.igsApiClientService.get(url);
  }
}